import { RedirectKeys } from "@entrilia/shared/auth/authTypes";
import { authState, redirectToB2CAuth } from "@entrilia/shared/auth/b2c/redirects";
import { getVariables } from "../variables";
import { impersonationStateParams } from "./impersonationHandler";

export function redirectToB2CAuthWithImpersonation() {
  if (authState[impersonationStateParams.impersonation] === true) {
    redirectToEntriliaLogin();
  } else {
    redirectToB2CAuth();
  }
}

function redirectToEntriliaLogin() {
  const currentUrl = new URL(window.location.href);
  const search = buildSearchStringWithImpersonation();

  const redirectUrlParams = new URLSearchParams();
  redirectUrlParams.set(
    RedirectKeys.State,
    JSON.stringify({ origin: currentUrl.origin, originalPath: `${currentUrl.pathname}?${search}` })
  );

  window.location.href = `${getVariables().LOGIN_APP_URI}/signin?${redirectUrlParams.toString()}`;
}

function buildSearchStringWithImpersonation(): string {
  const currentUrl = new URL(window.location.href);
  const params = new URLSearchParams(currentUrl.search);
  params.set(impersonationStateParams.impersonation, "true");

  const addParamFromAuthState = (key: string) => {
    if (typeof authState[key] === "string" && params.get(key) === null) {
      params.set(key, authState[key]);
    }
  };

  addParamFromAuthState(impersonationStateParams.client);
  addParamFromAuthState(impersonationStateParams.user);
  addParamFromAuthState(impersonationStateParams.target);
  addParamFromAuthState(impersonationStateParams.fund);

  return params.toString();
}
